import useUploadedDocuments from './useUploadedDocuments';

export { useUploadedDocuments };
